import styled from 'styled-components';
import HyperLink from 'components/Core/HyperLink';

// eslint-disable-next-line import/prefer-default-export
export const LoginContainer = styled.div`
  padding: 42px 40px;
  min-height: 547px;
  background: white;
  border-radius: 4px;

  > h4 {
    width: 100%;
    text-align: center;
  }
  .input-failed-value {
    color: var(--critical-3);
  }

  .login-modal--separator {
    text-align: center;
    margin-top: 45px;

    hr {
      margin-top: 20px;
      border: 1px solid var(--grey-3);
    }

    p {
      margin: 0;
      position: absolute;
      margin-top: -23px;
      background: var(--white);
      left: 50%;
      transform: translateX(-50%);
      padding: 0 15px;
      color: var(--skyline-6);
      font-size: var(--font-size-h5);
    }
  }

  .login-modal--form-container {
    margin-top: 40px;

    > h6 {
      width: 100%;
      text-align: center;
      margin-bottom: 0;
      margin-top: 25px;
    }

    .login-modal--form-item {
      margin-bottom: 20px;
    }

    .login-modal--signup-link {
      font-size: var(--font-size-h5);
      font-weight: var(--font-weight-500);
      text-align: center;
      margin-top: 30px;
    }

    @media (max-width: 575px) {
      button {
        width: 100%;
      }
    }
  }

  @media (min-width: 576px) {
    width: 658px;
  }
`;

export const ForgotPasswordContainer = styled.div`
  padding: 42px 40px;
  min-height: 347px;
  > h4 {
    width: 100%;
    text-align: center;
  }
  .input-failed-value {
    color: var(--critical-3);
  }

  .login-modal--form-container {
    margin-top: 40px;

    > h6 {
      width: 100%;
      text-align: center;
      margin-bottom: 0;
      margin-top: 25px;
    }

    .login-modal--form-item {
      margin-bottom: 20px;
    }

    .login-modal--signup-link {
      font-size: var(--font-size-h5);
      font-weight: var(--font-weight-500);
      text-align: center;
      margin-top: 30px;
    }
  }
`;

export const ForgotPasswordLink = styled(HyperLink)`
  display: block;
  text-align: right;
  width: 100%;
  margin: -15px 0 15px 0;
  font-size: var(--font-size-16);
  line-height: var(--line-height-150);
  color: var(--darkest);

  @media (max-width: 575px) {
    margin: 0 0 15px 0;
  }
`;
